import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/shared/material.module';
import { NotificationEventDetailsPipe } from 'src/app/shared/pipes/notification-event-details.pipe';
import { NotificationEventCategory } from '../enums/notification-event-category.enum';
import { NotificationEventResult } from '../enums/notification-event-result.enum';
import { APP_DATE_FORMAT } from 'src/app/shared/services/helpers/date.helper';
import { NotificationHistoryEntry } from '../models/notification-history-entry';
import { NotificationHistoryDetailDialogComponent } from './notification-history-detail-dialog/notification-history-detail-dialog.component';
import { NotificationEventType } from '../enums/notification-event-type.enum';

@Component({
  selector: 'app-notification-history',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, TranslateModule, MaterialModule, NotificationEventDetailsPipe],
  templateUrl: './notification-history.component.html',
  styleUrl: './notification-history.component.scss',
})
export class NotificationHistoryComponent {
  private dialog = inject(MatDialog);

  history = input.required<NotificationHistoryEntry[]>();
  readonly tableColumns = [
    'eventType',
    'eventDetails',
    'lastModifiedBy',
    'eventTimestamp',
    'recipients',
  ];

  readonly Category = NotificationEventCategory;
  readonly Result = NotificationEventResult;
  readonly dateFormat = APP_DATE_FORMAT + ' HH:mm';

  openDetail(entry: NotificationHistoryEntry): void {
    this.dialog.open(NotificationHistoryDetailDialogComponent, { data: entry, width: '480px' });
  }

  chipClass(): string {
    return 'nh-chip--neutral';
  }

  chipIcon(entry: NotificationHistoryEntry): string {
    switch (entry.eventType) {
      case NotificationEventType.PLANNED_LEAVES_NOTIFICATION:
      case NotificationEventType.SETUP_REMINDER_NOTIFICATION:
      case NotificationEventType.WORK_REPORT_NOTIFICATION:
      case NotificationEventType.MISSING_TIME_LOG_NOTIFICATION:
      case NotificationEventType.BANK_HOLIDAYS_REVIEW_REMINDER:
        return 'send';
      case NotificationEventType.NOTIFICATION_DATES_AUTO_SETUP:
      case NotificationEventType.TIME_LOGGING_DEADLINE_INIT:
      case NotificationEventType.PLANNED_LEAVES_NOTIFICATION_DATE_INIT:
      case NotificationEventType.WORK_REPORT_NOTIFICATION_DATE_INIT:
      case NotificationEventType.MISSING_TIME_LOG_FIRST_NOTIFICATION_DATE_INIT:
      case NotificationEventType.MISSING_TIME_LOG_SECOND_NOTIFICATION_DATE_INIT:
        return 'schedule';
      case NotificationEventType.PLANNED_LEAVES_BODY_UPDATE:
        return 'edit_note';
      default:
        return 'edit_calendar';
    }
  }
}
